import styled from "styled-components";

const SectionDivider = styled.div`
  border-top: var(--p-border-divider);
`;

export default SectionDivider;
